import React from "react";
import { getImageUrl } from "utils/imageHelper";

export default function ViewMasterCompanyDetails({ data }) {
  if (!data) return null;

  // Resolve logo URL
  const logoUrl = data.masterCompanyLogo
    ? getImageUrl(data.masterCompanyLogo)
    : typeof data.masterCompanyLogo === "string"
    ? data.masterCompanyLogo
    : null;

  return (
    <div className="flex flex-col gap-6 text-sm text-gray-800">
      <div className="view-card flex flex-col gap-6 text-sm">
        {/* SECTION 1: COMPANY DETAILS */}

        <div className="view-subtitle">
          <span>Company Details</span>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p className="view-label">Company Name</p>
            <p className="view-value font-semibold">
              {data.masterCompanyName || "N/A"}
            </p>
          </div>
          <div>
            <p className="view-label">Email</p>
            <p className="view-value">{data.masterCompanyEmail || "N/A"}</p>
          </div>
          <div>
            <p className="view-label">Phone Country Code</p>
            <p className="view-value">
              {data.masterCompanyMobileCountryCode || "+91"}
            </p>
          </div>
          <div>
            <p className="view-label">Phone Number</p>
            <p className="view-value">{data.masterCompanyMobile || "N/A"}</p>
          </div>
          <div>
            <p className="view-label">GST Number</p>
            <p className="view-value">{data.gstNumber || "N/A"}</p>
          </div>
          <div>
            <p className="view-label">Primary Color</p>
            <div className="view-value flex items-center gap-2">
              {data.primaryColor ? (
                <>
                  <span
                    className="view-color-box"
                    style={{ backgroundColor: data.primaryColor }}
                  />
                  <span className="font-mono uppercase">
                    {data.primaryColor}
                  </span>
                </>
              ) : (
                "N/A"
              )}
            </div>
          </div>
          <div>
            <p className="view-label">Country</p>
            <p className="view-value">{data.masterCompanyCountry || "N/A"}</p>
          </div>
          <div>
            <p className="view-label">State</p>
            <p className="view-value">{data.masterCompanyState || "N/A"}</p>
          </div>
          <div>
            <p className="view-label">District</p>
            <p className="view-value">{data.masterCompanyDistrict || "N/A"}</p>
          </div>
          <div className="md:col-span-2">
            <p className="view-label">Company Address</p>
            <p className="view-value">{data.masterCompanyAddress || "N/A"}</p>
          </div>
        </div>
      </div>

      {/* SECTION 2: COMPANY MEDIA (Matching Reference Design) */}
      <div className="view-card flex flex-col gap-6">
        <div className="view-subtitle">
          <span>Company Media</span>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p className="view-label mb-1">Company Logo (120x40)</p>
            <div className="flex h-28 w-full items-center justify-center overflow-hidden rounded-xl border-2 border-dashed border-[var(--color-primary,#02a9e0)] bg-gray-50/50 p-3">
              {logoUrl ? (
                <img
                  src={logoUrl}
                  alt={data.masterCompanyName || "Company Logo"}
                  className="max-h-full max-w-full object-contain"
                />
              ) : (
                <span className="text-xs text-gray-400">No Logo Uploaded</span>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* SECTION 3: ADMIN DETAILS */}
      <div className="view-card flex flex-col gap-6">
        <div className="view-subtitle">
          <span>Admin Details</span>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p className="view-label">Admin Name</p>
            <p className="view-value">{data.adminName || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">Admin Email</p>
            <p className="view-value">{data.adminEmail || "N/A"}</p>
          </div>

          <div>
            <p className="view-label">Admin Phone Country Code</p>
            <p className="view-value">{data.adminMobileCountryCode || "+91"}</p>
          </div>

          <div>
            <p className="view-label">Admin Mobile</p>
            <p className="view-value">{data.adminMobile || "N/A"}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
